export interface RegionData {
  code: string;
  name: string;
  flag: string;
  lang: string;
  siteName: string;
  continent: string;
}

export const regions: RegionData[] = [
  // === AMERICAS ===
  { code: "US", name: "USA", flag: "🇺🇸", lang: "en", siteName: "Openlab Secure USA", continent: "Americas" },
  { code: "CA", name: "Canadá", flag: "🇨🇦", lang: "en", siteName: "Openlab Secure Canadá", continent: "Americas" },
  { code: "MX", name: "México", flag: "🇲🇽", lang: "es", siteName: "Openlab Secure México", continent: "Americas" },
  { code: "PE", name: "Perú", flag: "🇵🇪", lang: "es", siteName: "Openlab Secure Perú", continent: "Americas" },
  { code: "CL", name: "Chile", flag: "🇨🇱", lang: "es", siteName: "Openlab Secure Chile", continent: "Americas" },
  { code: "CO", name: "Colombia", flag: "🇨🇴", lang: "es", siteName: "Openlab Secure Colombia", continent: "Americas" },
  { code: "EC", name: "Ecuador", flag: "🇪🇨", lang: "es", siteName: "Openlab Secure Ecuador", continent: "Americas" },
  { code: "AR", name: "Argentina", flag: "🇦🇷", lang: "es", siteName: "Openlab Secure Argentina", continent: "Americas" },
  { code: "BR", name: "Brasil", flag: "🇧🇷", lang: "pt", siteName: "Openlab Secure Brasil", continent: "Americas" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪", lang: "es", siteName: "Openlab Secure Venezuela", continent: "Americas" },
  { code: "BO", name: "Bolivia", flag: "🇧🇴", lang: "es", siteName: "Openlab Secure Bolivia", continent: "Americas" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾", lang: "es", siteName: "Openlab Secure Uruguay", continent: "Americas" },
  { code: "PY", name: "Paraguay", flag: "🇵🇾", lang: "es", siteName: "Openlab Secure Paraguay", continent: "Americas" },
  { code: "PA", name: "Panamá", flag: "🇵🇦", lang: "es", siteName: "Openlab Secure Panamá", continent: "Americas" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷", lang: "es", siteName: "Openlab Secure Costa Rica", continent: "Americas" },
  { code: "GT", name: "Guatemala", flag: "🇬🇹", lang: "es", siteName: "Openlab Secure Guatemala", continent: "Americas" },
  { code: "DO", name: "República Dominicana", flag: "🇩🇴", lang: "es", siteName: "Openlab Secure República Dominicana", continent: "Americas" },
  { code: "PR", name: "Puerto Rico", flag: "🇵🇷", lang: "es", siteName: "Openlab Secure Puerto Rico", continent: "Americas" },

  // === EUROPE ===
  { code: "ES", name: "España", flag: "🇪🇸", lang: "es", siteName: "Openlab Secure España", continent: "Europe" },
  { code: "PT", name: "Portugal", flag: "🇵🇹", lang: "pt", siteName: "Openlab Secure Portugal", continent: "Europe" },
  { code: "FR", name: "Francia", flag: "🇫🇷", lang: "fr", siteName: "Openlab Secure Francia", continent: "Europe" },
  { code: "DE", name: "Alemania", flag: "🇩🇪", lang: "de", siteName: "Openlab Secure Alemania", continent: "Europe" },
  { code: "IT", name: "Italia", flag: "🇮🇹", lang: "it", siteName: "Openlab Secure Italia", continent: "Europe" },
  { code: "GB", name: "Reino Unido", flag: "🇬🇧", lang: "en", siteName: "Openlab Secure Reino Unido", continent: "Europe" },
  { code: "NL", name: "Países Bajos", flag: "🇳🇱", lang: "en", siteName: "Openlab Secure Países Bajos", continent: "Europe" },
  { code: "BE", name: "Bélgica", flag: "🇧🇪", lang: "fr", siteName: "Openlab Secure Bélgica", continent: "Europe" },
  { code: "CH", name: "Suiza", flag: "🇨🇭", lang: "de", siteName: "Openlab Secure Suiza", continent: "Europe" },
  { code: "SE", name: "Suecia", flag: "🇸🇪", lang: "en", siteName: "Openlab Secure Suecia", continent: "Europe" },
  { code: "NO", name: "Noruega", flag: "🇳🇴", lang: "en", siteName: "Openlab Secure Noruega", continent: "Europe" },
  { code: "DK", name: "Dinamarca", flag: "🇩🇰", lang: "en", siteName: "Openlab Secure Dinamarca", continent: "Europe" },
  { code: "FI", name: "Finlandia", flag: "🇫🇮", lang: "en", siteName: "Openlab Secure Finlandia", continent: "Europe" },
  { code: "PL", name: "Polonia", flag: "🇵🇱", lang: "en", siteName: "Openlab Secure Polonia", continent: "Europe" },
  { code: "IE", name: "Irlanda", flag: "🇮🇪", lang: "en", siteName: "Openlab Secure Irlanda", continent: "Europe" },
  { code: "AT", name: "Austria", flag: "🇦🇹", lang: "de", siteName: "Openlab Secure Austria", continent: "Europe" },
  { code: "CZ", name: "República Checa", flag: "🇨🇿", lang: "en", siteName: "Openlab Secure República Checa", continent: "Europe" },
  { code: "HU", name: "Hungría", flag: "🇭🇺", lang: "en", siteName: "Openlab Secure Hungría", continent: "Europe" },
  { code: "RO", name: "Rumania", flag: "🇷🇴", lang: "en", siteName: "Openlab Secure Rumania", continent: "Europe" },
  { code: "UA", name: "Ucrania", flag: "🇺🇦", lang: "en", siteName: "Openlab Secure Ucrania", continent: "Europe" },
  { code: "GR", name: "Grecia", flag: "🇬🇷", lang: "en", siteName: "Openlab Secure Grecia", continent: "Europe" },

  // === ASIA ===
  { code: "CN", name: "China", flag: "🇨🇳", lang: "zh", siteName: "Openlab Secure China", continent: "Asia" },
  { code: "JP", name: "Japón", flag: "🇯🇵", lang: "ja", siteName: "Openlab Secure Japón", continent: "Asia" },
  { code: "IN", name: "India", flag: "🇮🇳", lang: "en", siteName: "Openlab Secure India", continent: "Asia" },
  { code: "KR", name: "Corea del Sur", flag: "🇰🇷", lang: "en", siteName: "Openlab Secure Corea del Sur", continent: "Asia" },
  { code: "SG", name: "Singapur", flag: "🇸🇬", lang: "en", siteName: "Openlab Secure Singapur", continent: "Asia" },
  { code: "AE", name: "Emiratos Árabes Unidos", flag: "🇦🇪", lang: "en", siteName: "Openlab Secure Emiratos Árabes Unidos", continent: "Asia" },
  { code: "SA", name: "Arabia Saudita", flag: "🇸🇦", lang: "en", siteName: "Openlab Secure Arabia Saudita", continent: "Asia" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩", lang: "en", siteName: "Openlab Secure Indonesia", continent: "Asia" },
  { code: "IL", name: "Israel", flag: "🇮🇱", lang: "en", siteName: "Openlab Secure Israel", continent: "Asia" },

  // === AFRICA ===
  { code: "ZA", name: "Sudáfrica", flag: "🇿🇦", lang: "en", siteName: "Openlab Secure Sudáfrica", continent: "Africa" },
  { code: "EG", name: "Egipto", flag: "🇪🇬", lang: "en", siteName: "Openlab Secure Egipto", continent: "Africa" },

  // === OCEANIA ===
  { code: "AU", name: "Australia", flag: "🇦🇺", lang: "en", siteName: "Openlab Secure Australia", continent: "Oceania" },
  { code: "NZ", name: "Nueva Zelanda", flag: "🇳🇿", lang: "en", siteName: "Openlab Secure Nueva Zelanda", continent: "Oceania" },

  // === GLOBAL ===
  { code: "GLOBAL", name: "Global", flag: "🌐", lang: "en", siteName: "Openlab Secure Global", continent: "Global" },
  { code: "OTHER", name: "Otras regiones", flag: "🌍", lang: "en", siteName: "Openlab Secure", continent: "Global" },
];

export const globalRegion = regions.find((r) => r.code === "GLOBAL")!;

export const continentOrder = ["Americas", "Europe", "Asia", "Africa", "Oceania", "Global"];

export const continentNames: Record<string, string> = {
  Americas: "Américas",
  Europe: "Europa",
  Asia: "Asia",
  Africa: "África",
  Oceania: "Oceanía",
  Global: "Global",
};

export function getRegionsByContinent(): Record<string, RegionData[]> {
  const grouped: Record<string, RegionData[]> = {};
  for (const region of regions) {
    if (!grouped[region.continent]) grouped[region.continent] = [];
    grouped[region.continent].push(region);
  }
  return grouped;
}

export const langLabelMap: Record<string, string> = {
  es: "Español",
  en: "English",
  pt: "Português",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  zh: "中文",
  ja: "日本語",
};

export function findRegionByCountryCode(countryCode: string): RegionData | undefined {
  return regions.find((r) => r.code === countryCode);
}

export function getDefaultRegionForUnknownCountry(countryCode: string): RegionData {
  const latam = ["AR", "BO", "BR", "CL", "CO", "CR", "CU", "DO", "EC", "GT", "HN", "MX", "NI", "PA", "PE", "PR", "PY", "SV", "UY", "VE"];
  if (latam.includes(countryCode)) {
    return regions.find((r) => r.code === countryCode) || regions.find((r) => r.code === "PE")!;
  }
  const european = ["ES", "PT", "FR", "DE", "IT", "GB", "NL", "BE", "CH", "AT", "SE", "NO", "DK", "FI", "IE", "PL", "CZ", "HU", "RO", "BG", "HR", "SI", "SK", "LT", "LV", "EE", "LU", "MT", "CY", "GR", "UA"];
  if (european.includes(countryCode)) {
    return regions.find((r) => r.code === "ES") || globalRegion;
  }
  const asian = ["CN", "JP", "IN", "KR", "SG", "AE", "SA", "ID", "IL"];
  if (asian.includes(countryCode)) {
    return regions.find((r) => r.code === countryCode) || regions.find((r) => r.code === "SG") || globalRegion;
  }
  const african = ["ZA", "EG"];
  if (african.includes(countryCode)) {
    return regions.find((r) => r.code === countryCode) || regions.find((r) => r.code === "ZA") || globalRegion;
  }
  return globalRegion;
}